import Duck from 'extensible-duck'

export const PRODUCT_LIST_LAYOUT_VIEW = {
  GRID_VIEW: 'GRID_VIEW',
  BLOCK_VIEW: 'BLOCK_VIEW',
}

export default new Duck({
  namespace: 'content',
  store: 'visibility',
  types: ['SHOW', 'HIDE', 'CLEAN', 'VIEW'],
  initialState: {
    visible: [],
    hidden: [],
    view: null,
  },
  reducer: (state, action, duck) => {
    const hidden = state.hidden.filter(
      (hiddenElem) => hiddenElem !== action.elem,
    )
    const visible = state.visible.filter(
      (hiddenElem) => hiddenElem !== action.elem,
    )
    const { view } = state

    switch (action.type) {
      case duck.types.SHOW:
        return {
          visible: [action.elem].concat(visible),
          hidden,
          view,
        }
      case duck.types.HIDE:
        return {
          visible,
          hidden: [action.elem].concat(hidden),
          view,
        }
      case duck.types.VIEW:
        return { ...state, view: action.payload }
      case duck.types.CLEAN:
        return {
          visible: [],
          hidden: [],
          view: null,
        }
      default:
        return state
    }
  },
  creators: (duck) => ({
    show: (elem) => (dispatch) => dispatch({ type: duck.types.SHOW, elem }),
    hide: (elem) => (dispatch) => dispatch({ type: duck.types.HIDE, elem }),
    clean: () => (dispatch) => dispatch({ type: duck.types.CLEAN }),
    setView: (payload) => ({
      type: duck.types.VIEW,
      payload,
    }),
  }),
})
